module.exports = __webpack_public_path__ + "img/avatar-5.85371395.png";